import { useI18n } from '../../i18n';
import { formatEventDate } from '../../utils/competitionList';

function TournamentSelector({ tournaments, loading, error, onRetry, selectedId, onSelect }) {
  const { t } = useI18n();
  const isSelected = (id) => selectedId != null && String(selectedId) === String(id);

  return (
    <section className="card bracket-select-card">
      <h3 className="panel-title">{t('tournament.selector.title')}</h3>
      <div className="tournament-options tournament-options-compact">
        {loading && (
          <div className="list-status">
            <div className="skeleton-card" />
            <div className="skeleton-card" />
          </div>
        )}
        {!loading && error && tournaments.length === 0 && (
          <div className="list-status list-status-error">
            <p>{error}</p>
            <button type="button" className="btn btn-retry" onClick={onRetry}>
              {t('common.retry')}
            </button>
          </div>
        )}
        {!loading &&
          tournaments.map((tournament) => (
            <div
              key={tournament.id}
              role="button"
              tabIndex={0}
              className={`tournament-card${isSelected(tournament.id) ? ' selected' : ''}`}
              onClick={() => onSelect(tournament.id)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  onSelect(tournament.id);
                }
              }}
            >
              <div className="tournament-card-inner">
                <div className="tournament-info">
                  <div className="tournament-name">{tournament.name}</div>
                  <div className="tournament-meta">
                    {tournament.location && <span className="meta-chip">{tournament.location}</span>}
                    {tournament.eventAt && (
                      <span className="meta-chip">{formatEventDate(tournament.eventAt)}</span>
                    )}
                  </div>
                </div>
                <div className="tournament-check" aria-hidden="true" />
              </div>
            </div>
          ))}
      </div>
    </section>
  );
}

export default TournamentSelector;
